'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getQuickReplies = exports.getAllowUserInput = exports.getAllowMultiSelect = undefined;

var _getIn = require('transmute/getIn');

var _getIn2 = _interopRequireDefault(_getIn);

var _quickReplyAttachmentKeyPaths = require('../constants/quickReplyAttachmentKeyPaths');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getAllowMultiSelect = exports.getAllowMultiSelect = (0, _getIn2.default)(_quickReplyAttachmentKeyPaths.ALLOW_MULTI_SELECT);

var getAllowUserInput = exports.getAllowUserInput = (0, _getIn2.default)(_quickReplyAttachmentKeyPaths.ALLOW_USER_INPUT);

var getQuickReplies = exports.getQuickReplies = (0, _getIn2.default)(_quickReplyAttachmentKeyPaths.QUICK_REPLIES);